import type { Project } from '@/services/types';

const DetailsTab = ({ data }: { data: Project }) => {
  return (
    <div className='space-y-5'>
      <div>
        <p className='font-bold'>Project Status</p>
        <p>{data?.status}</p>
      </div>

      <div>
        <p className='font-bold'>Timeline</p>
        <p>{data?.timeline}</p>
      </div>

      <div>
        <p className='font-bold'>Geographic Scope</p>
        <div className='grid grid-cols-2 gap-2'>
          {data?.continent && (
            <div className='rounded-md border p-2'>
              <p className='font-bold'>Continent</p>
              <p>{data?.continent}</p>
            </div>
          )}
          {data?.region && (
            <div className='rounded-md border p-2'>
              <p className='font-bold'>Region</p>
              <p>{data?.region}</p>
            </div>
          )}
          {data?.country && (
            <div className='rounded-md border p-2'>
              <p className='font-bold'>Country</p>
              <p>{data?.country}</p>
            </div>
          )}
          {data?.state && (
            <div className='rounded-md border p-2'>
              <p className='font-bold'>State</p>
              <p>{data?.state}</p>
            </div>
          )}
        </div>
      </div>
      <div>
        <p className='font-bold'>Collaborating Organisations</p>
        <div className='mb-2 flex flex-wrap gap-3'>
          {data?.collaboratingOrganisations?.map((org: any, index: number) => (
            <div className='rounded-full border p-2' key={index}>
              {org}
            </div>
          ))}
        </div>
      </div>

      <div>
        <p className='font-bold'>Relevant Tags</p>
        <div className='flex gap-3'>
          {data?.tags?.map((tag: any, index: number) => (
            <div className='rounded-full border p-2' key={index}>
              {tag}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DetailsTab;
